import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'

import auth from 'src/slices/auth'
import charity from 'src/slices/charity'
import item from 'src/slices/item'
import offer from 'src/slices/offer'
import signup from 'src/slices/signup'
import location from 'src/slices/location'
import order from 'src/slices/order'
import modals from 'src/slices/modals'
import employee from 'src/slices/employee'
import info from 'src/slices/info'

const customizedMiddleware = getDefaultMiddleware({
	serializableCheck: false,
})

const store = configureStore({
	reducer: {
		auth,
		charity,
		employee,
		info,
		item,
		location,
		modals,
		offer,
		order,
		signup,
	},
	middleware: customizedMiddleware,
})
export default store
